import "./App.scss";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Home from "./components/Home";
import Careers from "./components/Careers";
import ContactUs from "./components/ContactUs";
import Navbar from "./components/Navbar";
import Services from "./components/Services";
import ServiceType from "./components/Services/ServiceType";
import Footer from "./components/Footer";
import CareersCRUD from "./components/CareersCRUD";
import CreateJob from "./components/CreateJob";
import DetailJobView from "./components/DetailJobView";

const App = () => {
  return (
    <Router>
      <div className="container">
        <Navbar />
        <div className="feedContainer">
          {/* routes of web-app */}
          <Routes>
            <Route exact path="/" element={<Home />} />
            <Route exact path="/services" element={<Services />} />
            <Route exact path="/services/:type" element={<ServiceType />} />
            <Route exact path="/careers" element={<Careers />} />
            <Route
              exact
              path="/careers/apply-now/:jobId"
              element={<DetailJobView isApplyNow={true} />}
            />
            <Route
              exact
              path="/careers/view-job/:jobId"
              element={<DetailJobView />}
            />
            <Route
              exact
              path={`/careers/${process.env.REACT_APP_CAREER_CRUD_ROUTE}`}
              element={<CareersCRUD />}
            />
            <Route
              exact
              path={`/careers/${process.env.REACT_APP_CAREER_CRUD_ROUTE}/view-job/:jobId`}
              element={<DetailJobView />}
            />
            <Route
              exact
              path={`/careers/${process.env.REACT_APP_CAREER_CRUD_ROUTE}/create-job`}
              element={<CreateJob />}
            />
            <Route exact path="/about-us/:type" element={<ServiceType />} />
            <Route exact path="/contact-us" element={<ContactUs />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
